import Swiper from "swiper";
import { Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs, EffectFade, Autoplay } from "swiper/modules";
/**
 * @param swiperInit
 */
export default function swiperInit() {
	var slideSectionHome1 = new Swiper(".section-home-1 .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		modules: [Navigation, EffectFade, Autoplay, Pagination],
		speed: 1000,
		autoplay: {
			delay: 5000,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: ".section-home-1 .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
		navigation: {
			nextEl: `.section-home-1 .btn-next`,
			prevEl: `.section-home-1 .btn-prev`,
		},
	});
	var slideSectionHome4 = new Swiper(".section-home-4 .swiper", {
		slidesPerView: 1.1,
		spaceBetween: 15,
		breakpoints: {
			768: {
				slidesPerView: 2.3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 25,
			},
		},
	});
	var slideSectionHome5 = new Swiper(".section-home-5 .swiper", {
		slidesPerView: 1.1,
		spaceBetween: 15,
		breakpoints: {
			768: {
				slidesPerView: 2.3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 2.5,
				spaceBetween: 25,
			},
		},
	});
	var slideSectionHome7 = new Swiper(".section-home-7 .swiper", {
		slidesPerView: 1.1,
		spaceBetween: 15,
		modules: [Navigation, Pagination],
		pagination: {
			el: ".section-home-7 .swiper-pagination",
			type: "progressbar",
		},
		navigation: {
			nextEl: `.section-home-7 .btn-next`,
			prevEl: `.section-home-7 .btn-prev`,
		},
		breakpoints: {
			768: {
				slidesPerView: 2.3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 2.4,
				spaceBetween: 25,
			},
		},
	});
	var slideSectionActivityField = new Swiper(".section-activity-detail.section-2 .swiper", {
		slidesPerView: 1,
		spaceBetween: 24,
		observer: true,
		observeParents: true,
		modules: [Navigation],
		navigation: {
			nextEl: `.section-activity-detail.section-2 .btn-next`,
			prevEl: `.section-activity-detail.section-2 .btn-prev`,
		},
	});
	var slideSectionActivityField_3 = new Swiper(".section-activity-detail.section-3 .swiper", {
		slidesPerView: 1.3,
		spaceBetween: 24,
		modules: [Navigation],
		navigation: {
			nextEl: `.section-activity-detail.section-3 .btn-next`,
			prevEl: `.section-activity-detail.section-3 .btn-prev`,
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 24,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 24,
			},
		},
	});
	const totalSlide = $(".section-infomation-disclosure .swiper .swiper-slide").length;
	console.log("🚀 ~ swiperInit ~ totalSlide:", totalSlide)
	var slideYears = new Swiper(".section-infomation-disclosure .swiper", {
		spaceBetween: 30,
		slidesPerView: 3,
		initialSlide: totalSlide - 1,
		freeMode: true,
		watchSlidesProgress: true,
		// loop: true,
		// centeredSlides: true,
		// watchOverflow: true,
		// updateOnWindowResize: true,
		slideToClickedSlide: true,
		breakpoints: {
			768: {
				slidesPerView: 7,
			},
		},
		on: {
			init: function () {
				// this.slideTo(this.slides.length - 1);
			},
			slideChange: function (e) {},
		},
	});
	var slideRecruitment = new Swiper(".recruitment-list .swiper", {
		slidesPerView: 1,
		spaceBetween: 24,
		modules: [Navigation],
		navigation: {
			nextEl: `.recruitment-list .btn-next`,
			prevEl: `.recruitment-list .btn-prev`,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
	});
}
